import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-success-snackbar',
  imports: [MatIconModule],
  templateUrl: './success-snackbar.html',
  styleUrl: './success-snackbar.scss'
})
export class SuccessSnackbar {
  constructor(
    public snackBarRef: MatSnackBarRef<SuccessSnackbar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string }
  ) { }
  
  close() {
    this.snackBarRef.dismiss();
  }

}
